// components/TicketDownloadButton.tsx
import { Button, useToast } from "@chakra-ui/react";
import axios from "axios";

interface Props {
    bookingId: string;
    user: {
        name: string;
        surname: string;
        email: string;
    };
}

const TicketDownloadButton: React.FC<Props> = ({ bookingId, user }) => {
    const toast = useToast();

    const downloadTicket = async () => {
        try {
            const res = await axios.post(
                `http://localhost:5000/api/tickets/${bookingId}`,
                { user },
                { responseType: "blob" }
            );

            const blob = new Blob([res.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `ticket-${bookingId}.pdf`;
            a.click();
            toast({ title: "Ticket downloaded", status: "success" });
        } catch (err) {
            toast({ title: "Failed to download ticket", status: "error" });
            console.error(err);
        }
    };

    return (
        <Button colorScheme="teal" onClick={downloadTicket}>
            Download Ticket
        </Button>
    );
};

export default TicketDownloadButton;
